import { Request } from 'commons/utils/request'
import { ManageInvoiceSubmittalFormType } from '~bank-invoices/types/Manage'

export type InvoiceSubmittalFormRequest = ManageInvoiceSubmittalFormType & { licenseId: number }

export const saveInvoice = (item: InvoiceSubmittalFormRequest) => {
  const func = item.id ? Request.put : Request.post
  return func(Request.urls.bank.invoiceSubmittal, item)
}
